import { Link } from "react-router-dom";
import styled from "styled-components";
import config, { whatsappLink } from "../config";
import data from "../data/products.json";
import logo from "../assets/logo.png";
import asites from "../assets/asites-logo.png";

// Kreditet e agjencisë — të njëjta në çdo projekt.
const AGENCY = {
  label: "Built by:",
  name: "ASites",
  url: "https://asitesagency.com",
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <Wrap>
      <Inner>
        <Top>
          <Brandry>
            <Logo>
              <img src={logo} alt="" width="52" height="52" />
              <span>{config.brand.name}</span>
            </Logo>
            <Blurb>
              Inhalatorë me vajra esencialë 100% organikë, të prodhuar në
              Zvicër. Të vegjël sa t'i mbash në xhep, dhe zgjasin deri në
              gjashtë muaj.
            </Blurb>
          </Brandry>

          <Col>
            <ColTitle>Produktet</ColTitle>
            {data.products.map((p) => (
              <FLink key={p.slug} to={`/produktet/${p.slug}`}>
                {p.name}
              </FLink>
            ))}
          </Col>

          <Col>
            <ColTitle>Faqet</ColTitle>
            <FLink to="/produktet">Të gjitha produktet</FLink>
            <FLink to="/rreth-nesh">Rreth nesh</FLink>
            <FLink to="/pyetje">Pyetje të shpeshta</FLink>
            <FLink to="/kontakt">Kontakt</FLink>
          </Col>

          <Col>
            <ColTitle>Porosit</ColTitle>
            <FA href={whatsappLink()} target="_blank" rel="noopener noreferrer">
              WhatsApp
            </FA>
            <FA
              href={config.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </FA>
            <FA
              href={config.social.tiktok}
              target="_blank"
              rel="noopener noreferrer"
            >
              TikTok
            </FA>
            <FA
              href={config.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </FA>
          </Col>
        </Top>

        <Note>
          Aroma Stick është produkt aromaterapie, jo ilaç. Nuk zëvendëson
          këshillën ose trajtimin mjekësor. Nëse ke shqetësime shëndetësore,
          drejtohu te mjeku yt.
        </Note>

        <Bottom>
          <Legal>
            <span>
              © {year} {config.brand.name}
            </span>
            <Sep />
            <span>
              {config.price} · {config.shipping}
            </span>
          </Legal>

          <Credit
            href={AGENCY.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${AGENCY.label} ${AGENCY.name}`}
          >
            <span>{AGENCY.label}</span>
            <img src={asites} alt={AGENCY.name} />
          </Credit>
        </Bottom>
      </Inner>
    </Wrap>
  );
}

const Wrap = styled.footer`
  background: ${({ theme }) => theme.colors.bgAlt};
  border-top: 1px solid ${({ theme }) => theme.colors.line};
  /* Hapësira poshtë është e qëllimshme: butoni i WhatsApp-it rri fiks në
     fund-djathtas dhe do ta mbulonte rreshtin e fundit pa të. */
  padding: 72px 0 96px;

  ${({ theme }) => theme.bp.md} {
    padding: 72px 0 108px;
  }
`;

const Inner = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: 0 20px;

  ${({ theme }) => theme.bp.md} {
    padding: 0 40px;
  }
`;

const Top = styled.div`
  display: grid;
  gap: 44px;
  grid-template-columns: 1fr;

  ${({ theme }) => theme.bp.sm} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ theme }) => theme.bp.md} {
    grid-template-columns: 1.6fr 1fr 1fr 1fr;
    gap: 56px;
  }
`;

const Brandry = styled.div``;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.xl};
  margin-bottom: 16px;

  img {
    width: 52px;
    height: 52px;
    object-fit: contain;
  }
`;

const Blurb = styled.p`
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${({ theme }) => theme.size.sm};
  max-width: 38ch;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

const ColTitle = styled.h4`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.size.xs};
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.inkFaint};
  margin-bottom: 6px;
`;

const linkStyle = `
  font-size: 0.93rem;
  transition: color 0.25s ease, transform 0.25s ease;
  width: fit-content;
`;

const FLink = styled(Link)`
  ${linkStyle};
  color: ${({ theme }) => theme.colors.inkSoft};
  &:hover {
    color: ${({ theme }) => theme.colors.brand};
    transform: translateX(3px);
  }
`;

const FA = styled.a`
  ${linkStyle};
  color: ${({ theme }) => theme.colors.inkSoft};
  &:hover {
    color: ${({ theme }) => theme.colors.brand};
    transform: translateX(3px);
  }
`;

const Note = styled.p`
  margin-top: 56px;
  padding-top: 26px;
  border-top: 1px solid ${({ theme }) => theme.colors.line};
  font-size: ${({ theme }) => theme.size.xs};
  color: ${({ theme }) => theme.colors.inkFaint};
  max-width: 72ch;
  line-height: 1.7;
`;

const Bottom = styled.div`
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px 24px;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.size.xs};
  color: ${({ theme }) => theme.colors.inkFaint};
`;

const Legal = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
`;

const Sep = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.5;

  @media (max-width: 420px) {
    display: none;
  }
`;

const Credit = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 7px 13px 7px 14px;
  border-radius: ${({ theme }) => theme.radius.pill};
  border: 1px solid transparent;
  color: ${({ theme }) => theme.colors.inkFaint};
  transition:
    border-color 0.35s ease,
    background 0.35s ease,
    transform 0.35s ${({ theme }) => theme.ease};

  /* Kur rreshti thyhet, pill-i shkon majtas — zhvendoset sa padding-u që
     teksti të rreshtohet me "© ..." sipër. */
  @media (max-width: 859px) {
    margin-left: -14px;
  }

  img {
    height: 27px;
    width: auto;
    /* Logoja e ASites është gri+blu; këtu mbahet e qetë dhe ndizet në hover,
       që kreditet të mos konkurrojnë me markën e klientit. */
    transition:
      opacity 0.35s ease,
      filter 0.35s ease;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.inkSoft};
    border-color: ${({ theme }) => theme.colors.line};
    background: ${({ theme }) => theme.colors.surface};
    transform: translateY(-1px);
  }

  &:hover img {
    opacity: 1;
    filter: none;
  }
`;
